// ============================================================================
// JobEditForm Component (View)
// ============================================================================

import { Box } from "@mui/material";
import type { JobEditFormProps } from "./MissingInvalidData.types";
import { useJobEditFormViewModel } from "./JobEditForm.vm";
import { ValidationErrorsContext } from "../../../../ImportTable/ValidationErrorsContext";
import { JobFormFields } from "../../../../shared/JobFormFields";
import { JobCardMap } from "../../../../ImportTable/JobCardMap";

/**
 * Form component for editing job data with validation.
 * Uses the shared JobFormFields component for consistent form layout.
 */
export function JobEditForm(props: JobEditFormProps) {
	const vm = useJobEditFormViewModel(props);
	const { currentJob, columnContext, isVisible, localValidationErrors, gridSizes, depths, labPackages, micros } = vm;
	const { branches = [] } = props.formContext;

	return (
		<ValidationErrorsContext.Provider value={localValidationErrors}>
			<Box sx={{ display: "flex", gap: 2, minHeight: 400 }}>
				{/* Form Fields - Left Side */}
				<Box sx={{ flex: "0 0 60%", overflowY: "auto", pr: 2 }}>
					<JobFormFields
						job={currentJob}
						columnContext={columnContext}
						dropdownOptions={{ gridSizes, depths, labPackages, micros }}
						branches={branches}
						isVisible={isVisible}
					/>
				</Box>

				{/* Map Preview - Right Side */}
				<Box sx={{ flex: 1, minWidth: 0, borderLeft: 1, borderColor: "divider", pl: 2 }}>
					<JobCardMap job={currentJob} height="100%" />
				</Box>
			</Box>
		</ValidationErrorsContext.Provider>
	);
}
